const storePendingCredentialInSessionStorage = (credential) => {
  window.sessionStorage.setItem('anova_pending_credential', JSON.stringify(credential))
}

export default storePendingCredentialInSessionStorage
